export default function formatDateTime(timestamp) {
    if (!timestamp) {
        return '';
    }
    const d = new Date(`${ timestamp }Z`);

    const year = d.getFullYear();
    const month = (d.getMonth() + 1).toString().padStart(2, '0');
    const day = d.getDate().toString().padStart(2, '0');

    const hours = d.getHours().toString().padStart(2, '0');
    const minutes = d.getMinutes().toString().padStart(2, '0');

    return `${ day }.${ month }.${ year } | ${ hours }.${ minutes }`;
}


export function formatDateTimeLogs(timestamp) {
    const d = new Date(timestamp);

    const year = d.getFullYear();
    const month = (d.getMonth() + 1).toString().padStart(2, '0');
    const day = d.getDate().toString().padStart(2, '0');

    const hours = d.getHours().toString().padStart(2, '0');
    const minutes = d.getMinutes().toString().padStart(2, '0');
    const seconds = d.getSeconds().toString().padStart(2, '0');

    return `${ year }-${ month }-${ day } ${ hours }:${ minutes }:${ seconds }`;
}
